
export default function PasswordResetFormController(
  $location,
  $rootScope,
  $timeout,
  alerts,
  authorizationService,
  userService,
  loaderService
) {
  const vm = this;

  // Set Default Values
  vm.appIsLoaded = false;
  vm.loginIsProcessing = false;

  // Attach Event Handlers
  vm.handleFormSubmit = _handleFormSubmit;
  vm.backToPassword = _backToPassword;
  _activate();

  /** ***********************************************
   * Event Handlers
   */

  function _handleFormSubmit() {
    _backToPassword();
  }

  function _backToPassword() {
    $location.path('/password');
  }

  /** ***********************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showViewLoader = false;
    vm.appIsLoaded = true;
  }
}

PasswordResetFormController.$inject = [
  '$location',
  '$rootScope',
  '$timeout',
  'alerts',
  'authorizationService',
  'userService',
  'loaderService',
];
